import React from 'react';
import { useTranslation } from 'react-i18next';
import { HowItWorksMessages } from './HowItWorks.messages';

export const HowItWorks: React.FC = () => {
  const { t } = useTranslation();
  const steps = [
    { number: '1', title: t(HowItWorksMessages.STEP1_TITLE), description: t(HowItWorksMessages.STEP1_DESCRIPTION), details: t(HowItWorksMessages.STEP1_DETAILS) },
    { number: '2', title: t(HowItWorksMessages.STEP2_TITLE), description: t(HowItWorksMessages.STEP2_DESCRIPTION), details: t(HowItWorksMessages.STEP2_DETAILS) },
    { number: '3', title: t(HowItWorksMessages.STEP3_TITLE), description: t(HowItWorksMessages.STEP3_DESCRIPTION), details: t(HowItWorksMessages.STEP3_DETAILS) },
  ];

  return (
    <section className="how-it-works">
      <div className="container">
        <div className="section-header">
          <h2>{t(HowItWorksMessages.TITLE)}</h2>
          <p className="section-subtitle">{t(HowItWorksMessages.SUBTITLE)}</p>
        </div>

        <div className="steps-grid">
          {steps.map((step, index) => (
            <div key={index} className="step-card">
              <div className="step-number" aria-hidden="true">{step.number}</div>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
                <p className="step-details">{step.details}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};
